import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';

const CategoryTreeView = ({ categories, onCreateChild, onDeleteCategory }) => {
    const [expandedParents, setExpandedParents] = useState({});

    const toggleParent = (parentId) => {
        setExpandedParents(prev => ({
            ...prev,
            [parentId]: !prev[parentId]
        }));
    };

    if (!categories || categories.length === 0) {
        return <div className="text-muted">No categories available.</div>;
    }

    return (
        <div>
            {categories.map((parent) => (
                <div key={parent.id} className="mb-3">
                    <div className="d-flex justify-content-between align-items-center p-2 border rounded">
                        <div className="d-flex align-items-center">
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => toggleParent(parent.id)}
                                className="p-0 me-2"
                                style={{ textDecoration: 'none' }}
                            >
                                {expandedParents[parent.id] ? '▼' : '▶'}
                            </Button>
                            <strong>{parent.name}</strong>
                            <Badge bg="secondary" className="ms-2">Level 1</Badge>
                            {parent.description && (
                                <span className="text-muted ms-2 small">- {parent.description}</span>
                            )}
                        </div>
                        <div>
                            <Button
                                variant="outline-success"
                                size="sm"
                                onClick={() => onCreateChild(parent.id)}
                                className="me-2"
                            >
                                + Add Child
                            </Button>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => onDeleteCategory(parent.id, true)}
                            >
                                Delete
                            </Button>
                        </div>
                    </div>

                    {expandedParents[parent.id] && (
                        <div className="ms-4 mt-2">
                            {parent.children && parent.children.length > 0 ? (
                                parent.children.map((child) => (
                                    <div
                                        key={child.id}
                                        className="d-flex justify-content-between align-items-center p-2 mb-2 border rounded bg-light"
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="me-2">├─</span>
                                            <strong>{child.name}</strong>
                                            <Badge bg="info" className="ms-2">Level 2</Badge>
                                            {child.description && (
                                                <span className="text-muted ms-2 small">- {child.description}</span>
                                            )}
                                        </div>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => onDeleteCategory(child.id, false)}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                ))
                            ) : (
                                <div className="text-muted ms-4 small">No child categories</div>
                            )}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default CategoryTreeView;

